import { OVERRIDES_ENUMS } from '../components/DisplayFeedOverrides';

const STARTING_AT_KEYS = ['lowestPrice'];
const LEASE_KEYS = ['leaseMonthlyPayment', 'leaseMonths', 'leaseDownPayment'];
const PURCHASE_KEYS = ['purchaseApr', 'purchaseMonths', 'purchaseDownpayment'];

const createObjWithKeysValues = (keys, value) => {
  const newValues = {};
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    newValues[key] = value;
  }
  return newValues;
};

const overrideObj = (obj, override, keysToRemove = []) => {
  const removedValues = createObjWithKeysValues(keysToRemove, '');
  return { ...obj, ...override, ...removedValues };
};

const overrideMaps = {
  [OVERRIDES_ENUMS.STARTING_AT]: (override) => (row) => overrideObj(row, override, [...LEASE_KEYS, ...PURCHASE_KEYS]),
  [OVERRIDES_ENUMS.LEASE]: (override) => (row) => overrideObj(row, override, [...STARTING_AT_KEYS, ...PURCHASE_KEYS]),
  [OVERRIDES_ENUMS.PURCHASE]: (override) => (row) => overrideObj(row, override, [...STARTING_AT_KEYS, ...LEASE_KEYS]),
  default: (override) => (row) => overrideObj(row, override)
};

export const mergeOverridesIntoFeed = (feed, overrides) => {
  const { active = 'default', ...overrideValues } = overrides;
  const overrideMap = overrideMaps[active](overrideValues);
  return feed.map(overrideMap);
};

export default {};



// WEBPACK FOOTER //
// ./src/feed-overrides/data/feed-overrides.js